import { createClient } from '@cms/i18n/shared';
import { type LocaleID } from '@common/clients/api';

import { I18N_NAMESPACES } from './namespaces';
import { I18N_RESOURCES } from './resources';
import { type Ns } from './types';

export const i18n = createClient({
    resources: I18N_RESOURCES,
    namespaces: I18N_NAMESPACES,
});

export function getT(locale: LocaleID, namespace: Ns) {
    return i18n.getFixedT(locale, namespace);
}
